import SimplePage from "../components/site/SimplePage";

const sections = [
  {
    title: "Education Access Drive",
    text: "Community campaign focused on school supplies, mentorship, and tutoring." 
  },
  {
    title: "Healthcare on Wheels",
    text: "Monthly outreach that brings doctors and nurses to remote villages." 
  },
  {
    title: "Women Led Enterprises",
    text: "Skill training and micro-finance support for women entrepreneurs." 
  }
];

function Campaign() {
  return (
    <SimplePage
      title="Campaigns"
      lead="Join campaigns that fund specific projects and deliver measurable outcomes."
      sections={sections}
    />
  );
}

export default Campaign;
